/* Stylesheet */

.status_container {
  margin: 0px 0px 0px 12px;
  display: flex;
  align-items: center;
  font-size: 0.875rem;

  .status {
    padding: 6px 21px 6px 21px;
    color: var(--ion-color-text-secondary);
    font-weight: 500;
    border-radius: 52px;
    box-shadow: var(--ion-box-shadow);
    text-transform: uppercase;
  }
}
